import { gql } from '@apollo/client'

export const userHashtagCreateMany = gql`
  mutation UserHashtagCreateMany($hashtags: [UserHashtagInput!], $folder: String) {
    userHashtagCreateMany(hashtags: $hashtags, folder: $folder)
  }
`
